import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import CustomerReport from '../../../../components/modules/report/customer-report';
import CustomerReportMiddleware from '../../../../middleware/modules/report/customer-report';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,customerReport }) => ({
  isProcessing: customerReport.isProcessing,
  isError: customerReport.isError,
  errorMessage: customerReport.errorMessage,
  dataList:customerReport.data,
  showModal:customerReport.showModal,
  helperList:customerReport.helperCustomerReport
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>CustomerReportMiddleware.getHelper(),
    reset: () =>CustomerReportMiddleware.resetList(),
    setData: (data) =>CustomerReportMiddleware.list(data),
    excel: (data) =>CustomerReportMiddleware.showExcel(data),
  }, dispatch);
};
class CustomerReportContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    dataList: PropTypes.any,
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
  }

  submitItem() {
    this.props.setData();
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.getHelper()
  }

  render() {
    const {dataList} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Customer Report")}
          </title>
        </Helmet>
      <CustomerReport
        {...this.props}
        data={dataList}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerReportContainer);
